import { useState, useEffect, useCallback } from "react";
import Layout from "../../components/Layout";
import Banner from "../../components/Banner";
import { getB2bBySlug } from "../../api/b2b.api";

const StoreDetails = () => {
  const [currentPage, setCurrentPage] = useState(null);

  const getCurrentPage = useCallback(async () => {
    try {
      const response = await getB2bBySlug("engen-distributor-locator");

      if (response.message === "success") {
        setCurrentPage(response.data.b2b);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    getCurrentPage();
  }, [getCurrentPage]);

  return (
    <Layout pageTitle="Store Details">
      <Banner
        title="Engen & Engen Distributor Locator"
        backgroundImage={currentPage && currentPage.image ? currentPage.image.path : ""}
      />
      <div
        id="351a1886-e123-46ee-84da-ca9472c3a4dc"
        className="LB_LocationDetails"
        template="Template4MediaBottomLeft"></div>
    </Layout>
  );
};

export default StoreDetails;
